export const URL = "https://newsansh.000webhostapp.com/"
// export const URL = "http://localhost/"